import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';

import { KYMW1202Component } from './kymw1202.component';
import { GetPublishMediumInfo } from './api-services/get-publish-medium-info.service';
import { UpdatePublishMediumSetting } from './api-services/update-publish-medium-setting.service';

/**
 * 掲載媒体設定画面 モジュール設定クラス
 *
 * @export KYMW1202Module
 * @class KYMW1202Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
  ],
  declarations: [KYMW1202Component],
  providers: [GetPublishMediumInfo, UpdatePublishMediumSetting],
})
export class KYMW1202Module {}
